module.exports = __webpack_public_path__ + "img/V55.8635da16.jpg";